module.exports = __webpack_public_path__ + "assets/img/border.0d333791.png";